import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { SecondaryButton } from '@components/Button/variants';
import IconError from '@components/Images/Rebranding/IconError';
import ResumeSubscriptionModal from '@components/pages/Settings/SettingsPage/Account/ResumeSubscriptionModal';
import { resume_subscription_path } from '@routes';

import Wrapper from './Wrapper';

interface UserStatusProps {
  buttonText?: string;
  copy: string;
  linkTo?: string;
  modalProps?: ResumeSubscriptionModalProps;
}

interface ResumeSubscriptionModalProps {
  nextBillingDate: string;
  nextBillingAmountWithTax: string;
  planName: string;
  isPro: boolean;
  canResumeCBPTSubscription: boolean;
}

const UserStatus = ({ buttonText, copy, linkTo, modalProps }: UserStatusProps): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isResumeSubscription = modalProps?.canResumeCBPTSubscription || false;

  const handleButtonClick = (e: React.MouseEvent) => {
    if (isResumeSubscription) {
      e.preventDefault();
      setIsModalOpen(true);
    }
  };

  const handleConfirmResume = () => {
    setIsModalOpen(false);
    window.location.href = resume_subscription_path();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Wrapper className="bg-grayscale-beige">
        <div className="w-max-[1024px] flex flex-row flex-wrap items-center justify-center gap-16 pb-10 sm:pb-0">
          <IconError fill="#f32a52" width="20" height="20" />
          <div className="text-center font-suisse-neue text-body-md font-normal text-black">
            {ReactHtmlParser(copy)}
          </div>
          {linkTo && buttonText && (
            <SecondaryButton
              as={isResumeSubscription ? 'button' : 'link'}
              href={isResumeSubscription ? undefined : linkTo}
              onClick={isResumeSubscription ? handleButtonClick : undefined}
              size="small"
            >
              {buttonText}
            </SecondaryButton>
          )}
        </div>
      </Wrapper>
      {isResumeSubscription && isModalOpen && (
        <ResumeSubscriptionModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirmResume}
          isPausedResumption={false}
          isPro={modalProps?.isPro}
          planName={modalProps?.planName}
          nextBillingDate={modalProps?.nextBillingDate}
          nextBillingAmount={modalProps?.nextBillingAmountWithTax}
        />
      )}
    </>
  );
};

export default UserStatus;
